var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconManage64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_19792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.21191 18.6665H54.7878",
    stroke: "#1E1E1E",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.21191 33.0513H54.7878",
    stroke: "#1E1E1E",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.21191 46.6396H54.7878",
    stroke: "#1E1E1E",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7606 22.9822C54.1021 22.9822 56.0002 21.084 56.0002 18.7425C56.0002 16.4011 54.1021 14.5029 51.7606 14.5029C49.4191 14.5029 47.521 16.4011 47.521 18.7425C47.521 21.084 49.4191 22.9822 51.7606 22.9822Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2396 37.3664C14.5811 37.3664 16.4792 35.4683 16.4792 33.1268C16.4792 30.7853 14.5811 28.8872 12.2396 28.8872C9.89814 28.8872 8 30.7853 8 33.1268C8 35.4683 9.89814 37.3664 12.2396 37.3664Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 50.5393C34.3413 50.5393 36.2395 48.6411 36.2395 46.2997C36.2395 43.9582 34.3413 42.0601 31.9999 42.0601C29.6584 42.0601 27.7603 43.9582 27.7603 46.2997C27.7603 48.6411 29.6584 50.5393 31.9999 50.5393Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.35
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_19792"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconManage64);
export default __webpack_public_path__ + "static/media/pictogramBeaconManage64.4421bf9d9ca216b1321454ec90f73fc3.svg";
export { ForwardRef as ReactComponent };